// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Twitter: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm4.566 7.8c.004.098.006.198.006.3v.045a6.484 6.484 0 0 1-6.485 6.485h-.048.002-.005a6.467 6.467 0 0 1-3.538-1.046l.025.015c.164.02.354.032.547.032h.009c1.077 0 2.068-.37 2.852-.99l-.01.007a2.3 2.3 0 0 1-2.139-1.578l-.005-.016a2.31 2.31 0 0 0 1.052-.043l-.016.004a2.304 2.304 0 0 1-1.841-2.25v-.035c.3.17.656.275 1.036.287h.004a2.302 2.302 0 0 1-.708-3.076l-.006.011a6.51 6.51 0 0 0 4.715 2.399l.016.001a2.236 2.236 0 0 1-.059-.52v-.004a2.3 2.3 0 0 1 3.97-1.571l.001.001a4.596 4.596 0 0 0 1.478-.57l-.021.012a2.32 2.32 0 0 1-.999 1.264l-.01.006a4.59 4.59 0 0 0 1.347-.374l-.029.012a4.718 4.718 0 0 1-1.13 1.183l-.013.009h.002Z" />
  </SvgIcon>
);

Twitter.activeColor = 'inherit';
Twitter.muiName = 'Twitter';
